// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  TransferInventoryContext,
  TransferInventoryProviderProps,
} from '@/items/contexts/transfer-inventory-context';
import { SparseItem, SparseLocation } from '@/sparse/api/types';
import { useState } from 'react';

/**
 * Provider component for the transfer inventory dialog context.
 */
export function TransferInventoryProvider(
  props: TransferInventoryProviderProps
) {
  const [isOpen, setIsOpen] = useState(false);
  const [item, setItem] = useState<SparseItem | undefined>(undefined);
  const [location, setLocation] = useState<SparseLocation | undefined>(
    undefined
  );

  const openDialog = (options?: {
    item?: SparseItem;
    location?: SparseLocation;
  }) => {
    setItem(options?.item);
    setLocation(options?.location);
    setIsOpen(true);
  };

  const closeDialog = () => {
    setIsOpen(false);
  };

  return (
    <TransferInventoryContext.Provider
      value={{
        isOpen,
        item,
        location,
        openDialog,
        closeDialog,
      }}
    >
      {props.children}
    </TransferInventoryContext.Provider>
  );
}
